import { OptionModel } from "../../common/types/OptionModel";

export const installmentType: OptionModel[] = [
    {
        value: 0, 
        label: "Tümü" 
    },
    { 
        value: 1, 
        label: "Peşin" 
    },
    { 
        value: 2, 
        label: "Taksit" 
    },
]